<template>
    <section class="esesja-modal">
        <section class="esesja-modal__wraper">
            <section class="esesja-modal__wraper__header">
                <h3 class="esesja-modal__wraper__header__title">{{$t('com.file.header-user-info.change-password')}}</h3>
                <button class="esesja-modal__wraper__header__exit-btn"
                        @click=" (e)=>{e.preventDefault(); this.$store.commit('hideShowUserChangeOwnPassword');}">
                    <img src="@/assets/icons/components/exit-btn.svg" />
                </button>
            </section>
            <perfect-scrollbar class="esesja-modal__wraper__body">
                <section class="esesja-modal__wraper__body__fallback-error" v-if="changePasswordError">
                    <img src="@/assets/icons/components/exit-btn.svg" class="esesja-modal__wraper__body__fallback-error__icon" :alt="$t('com.file.user-reset-password.error-icon')" />
                    <span class="esesja-modal__wraper__body__fallback-error__text">
                        {{$t('com.file.user-reset-password.check-data')}}
                    </span>
                </section>
                <label class="esesja-modal__wraper__body__label">{{$t('com.file.change-own-pin.current-password')}}</label>
                <section class="esesja-modal__row">
                    <input class="esesja-modal__wraper__body__input"
                           type="password"
                           v-model="passwords.oldPassword"
                           :placecholder="$t('com.file.change-own-pin.current-password')"
                           v-error="{ errors, input_key: 'oldPassword' }" />
                    <ErrorMessage v-if="isError('oldPassword', this.errors)"
                                  :errorMsgs="passErrorMsg('oldPassword', this.errors)" />
                </section>

                <label class="esesja-modal__wraper__body__label">{{$t('com.file.change-own-password-modal.new-password')}}</label>
                <section class="esesja-modal__row">
                    <section class="esesja-modal__wraper__body__input-with-button" :data-tip="passwordRulesHint">
                        <input class="esesja-modal__wraper__body__input"
                               :type="passwordFieldType"
                               v-model="passwords.newPassword"
                               :placecholder="$t('com.file.change-own-password-modal.new-password')"
                               v-error="{ errors, input_key: 'newPassword' }" />
                        <section class="esesja-modal__wraper__body__input__append-button" @click="switchVisibility">
                            <img src="@/assets/icons/eye.svg" />
                        </section>
                    </section>
                    <ErrorMessage v-if="isError('newPassword', this.errors)"
                                  :errorMsgs="passErrorMsg('newPassword', this.errors)" />
                </section>

                <label class="esesja-modal__wraper__body__label">{{$t('com.file.change-own-password-modal.repeat-new-password')}}</label>
                <section class="esesja-modal__row">
                    <section style="display: flex" :data-tip="passwordRulesHint">
                        <input class="esesja-modal__wraper__body__input"
                               :type="passwordFieldType"
                               v-model="passwords.confirmNewPassword"
                               :placecholder="$t('com.file.change-own-password-modal.new-password')"
                               v-error="{ errors, input_key: 'confirmNewPassword' }" />
                    </section>
                    <ErrorMessage v-if="isError('confirmNewPassword', this.errors)"
                                  :errorMsgs="passErrorMsg('confirmNewPassword', this.errors)" />
                </section>

                <section class="esesja-modal__wraper__body__bottom">
                    <button class="esesja-modal__wraper__body__bottom-button" @click="this.$store.commit('hideShowUserChangeOwnPassword')">{{$t('com.global.cancel')}}</button>
                    <button class="esesja-modal__wraper__body__bottom-button esesja-modal__wraper__body__bottom-button--red" @click="changePassword">{{$t('com.global.save')}}</button>
                </section>
            </perfect-scrollbar>
        </section>
        <LoaderInside v-if="isLoading" />
    </section>
</template>
<script charset="utf-8">
    import ErrorMessage from "@/components/BasicControls/ErrorMessage.vue";
    import {
        passErrorMsg,
        isError,
        setErrors,
    } from "@/formValidation/main";
    import UserService from "../../../../../services/user.service";
    import { PASSWORD_MIN_LENGTH, getPasswordRuleErrorMessage, getPasswordRulesHint } from "@/helpers/password.helper";
    export default {
        name: "ChangeOwnPasswordModal",
        components: {
            ErrorMessage
        },
        computed: {
            passwordRulesHint() {
                return getPasswordRulesHint((key) => this.$t(key));
            },
        },
        data() {
            return {
                passwords: {
                    oldPassword: "",
                    newPassword: "",
                    confirmNewPassword: "",
                },
                errors: [],
                changePasswordError: false,
                passwordFieldType: "password",
            }
        },
        methods: {
            async changePassword() {
                try {
                    this.changePasswordError = false;
                    this.$store.commit("showLoader");
                    if (!this.validate()) {
                        return;
                    }

                    let response = await UserService.updateOwnPassword(this.passwords);

                    if (response.status !== 200) {
                        throw await Promise.reject(response);
                    }

                    this.changePasswordError = !response.data;
                    if (response.data === true) {
                        this.$store.commit('hideShowUserChangeOwnPassword');
                        return;
                    }
                }
                catch (e) {
                    this.changePasswordError = true;
                    if (e.response.status == 404) {
                        this.$router.push({ name: 'notfoundpage', params: { pathMatch: 'sms' } });
                    }
                    else if (e.response.status == 401) {
                        this.$router.push({ name: 'Login' })
                    }
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            },
            switchVisibility() {
                if (this.passwordFieldType === "password") {
                    this.passwordFieldType = "text";
                }
                else {
                    this.passwordFieldType = "password";
                }
            },
            validate() {
                var validateStatus = true;
                var errors = {};

                if (this.passwords.oldPassword.length <= 0) {
                    validateStatus = false;
                    errors.oldPassword = [this.$t('com.global.required-field')] 
                }

                const newPasswordRuleError = getPasswordRuleErrorMessage(this.passwords.newPassword, (key) => this.$t(key));
                if (newPasswordRuleError !== null) {
                    validateStatus = false;
                    errors.newPassword = [newPasswordRuleError]
                }
                else {
                    if (this.passwords.oldPassword === this.passwords.newPassword) {
                        validateStatus = false;
                        errors.oldPassword = [this.$t('com.validation-error.pass-cant-be-same-like-old')]
                        errors.newPassword = [this.$t('com.validation-error.pass-cant-be-same-like-old')]
                    }
                }

                if (this.passwords.confirmNewPassword.length < PASSWORD_MIN_LENGTH) {
                    validateStatus = false;
                    errors.confirmNewPassword = [this.$t('com.validation-error.pass-min-12-length-error')]
                }
                else {
                    if (this.passwords.confirmNewPassword !== this.passwords.newPassword) {
                        validateStatus = false;
                        errors.newPassword = [this.$t('com.validation-error.pass-are-different')]
                        errors.confirmNewPassword = [this.$t('com.validation-error.pass-are-different')]
                    }
                }

                if (!validateStatus) {
                    this.isLoading = false;
                    this.errors = setErrors(errors)
                }

                return validateStatus;
            },
            passErrorMsg,
            setErrors,
            isError,
        }

    }
</script>
<style lang="scss" scoped>
    @use '@/assets/scss/esesja-modal.scss';
    @use  '@/assets/scss/esesja-data-tip.scss'; 
</style>